import { type Facet, type FacetAttribute, TweakwiseItem } from "@jog/types"

import { getGtmIdFromTW } from "../helper"
import { getImpressions, gtmPush } from "./index"

export const gtmPushAllListerProducts = (items: TweakwiseItem[]) => {
    if (!items.length) return
    const impressions = getImpressions(items)
    gtmPush({ event: "impression-send", ecommerce: { currencyCode: "EUR", impressions } })
}
export const gtmProductClickOnLister = (product: TweakwiseItem, _category?: string) => {
    if (!product) return
    if (!_category) return
    const category = _category.replace(/^\//, "")
    gtmPush({
        event: "productClick",
        ecommerce: {
            click: {
                actionField: { list: category },
                products: [
                    {
                        id: getGtmIdFromTW(product),
                        name: product.title,
                        price: product.price,
                        brand: product.brand,
                        category,
                        variant: "",
                    },
                ],
            },
        },
    })
}
export const gtmFacetSearch = (
    action: "check" | "uncheck",
    facet: Facet,
    attribute: FacetAttribute,
    searchTerm: string
) => {
    gtmPush({
        event: "facetSearch",
        ecommerce: {
            facet: [
                {
                    searchFacet: facet.facetsettings.attributename,
                    facetItemClicked: attribute.title,
                    action,
                    searchTerm,
                    pathname: window.location.pathname,
                },
            ],
        },
    })
}
